import React from "react";

const DashboardFillIcon = () => (
	<g>
		<path d='M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z' />
	</g>
);

export default DashboardFillIcon;
